<template>
    <div class="cart text-left">
        <a :href="$root.baseURL + 'cart'" class="btn btn-sm btn-outline-light">
            <i class="fa fa-shopping-basket"></i>
            سبد خرید
            <span class="num-fa">{{ total().toLocaleString() }} تومان</span>
        </a>
    </div>
</template>

<script>
export default {
    name: 'mini-cart',
    components: {},
    data() {
        let self = this;

        return {

        };
    },
    props: {

    },
    computed: {

    },
    methods: {
        total() {
            return this.$root.cart ? this.$root.cart.total() : '';
        }
    },
    mounted() {

    }
}
</script>
